import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { RecipientFlag } from './types/recipient-flag.type';

/**
 * Retrieves the recipient flags from the API.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @returns A promise that resolves to an OperationResultWithData containing an array of RecipientFlag objects.
 * @throws Throws an error if the request fails.
 */
export const getRecipientFlags = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<RecipientFlag[]>>(Uri.recipient.getFlags).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
